module.exports = __webpack_public_path__ + "img/warning.29d5ca6a.svg";